import { format } from "date-fns";

export const getTitlePlaceholder = () =>
  `Update - ${format(new Date(), "MMM dd")}`;
